import { useState } from 'react';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useLazyGetP2PReceiptQuery, useLazyGetP2PReceiptV2Query } from '../../services/receiptApi';
export function useGetP2PReceipt() {
    const { isFeatureFlagWhiteListed } = useFeatureFlag(undefined, { autoLoad: false });
    const isBaasV2 = isFeatureFlagWhiteListed(FeatureFlagUseCase.CORE_BANKING_ENABLE_BAAS_V2);
    const [triggerV1] = useLazyGetP2PReceiptQuery();
    const [triggerV2] = useLazyGetP2PReceiptV2Query();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [p2pReceipt, setP2pReceipt] = useState();
    async function getP2PReceipt(transactionId, coreBankId) {
        setLoading(true);
        setError(false);
        setP2pReceipt(undefined);
        try {
            const { data } = isBaasV2
                ? await triggerV2({ id: transactionId }, false)
                : await triggerV1({ transactionId, coreBankId }, false);
            if (!data?.result) {
                setError(true);
            }
            else {
                setP2pReceipt(data.result);
            }
        }
        catch {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        p2pReceipt,
        setP2pReceipt,
        getP2PReceipt,
    };
}
